import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://robsdyno.malejkoit.com/api/v1.0.0/"
    : "http://localhost:8000/api/v1.0.0/";

export const getBrandingLogoUrl = async () => {
  try {
    const response = await axios.get(`${API_URL}branding/`, {
      params: { hostname: window.location.hostname },
    });
    return response.data?.data?.logoUrl || null;
  } catch {
    return null;
  }
};
